import "./index.css";
import LandingView from "./Pages/LandingView";

function App() {
  return (
    <div>
      <LandingView />
    </div>
  );
}

export default App;
